<template>
    <div>
         <div class="main">
            <div class="title">
               抽奖分奖金
                <div @click="back" class="back">
                    <img src="icon/learnIcon/icon_liucheng_fanhui1.svg" alt="">
                </div>
            </div>
        </div>
        <div class="content">

            <div class="rule_btn" @click="scrollState">抽奖规则</div>

            <img class="img_bg" src="icon/awardIcon/award_bg.png" alt="">

            <!-- 抽奖模块 -->
            <award-model @showShare='getShare'
                 :awardList="this.lottoInfo ? this.lottoInfo.awardList : []"
                 :chanceCount="this.lottoInfo ? this.lottoInfo.lottoCount : 0"
                 :currentNumber="currentNumber"
                 :onStart="startMove"
                 :awardId="awardId"
            ></award-model>

            <!-- 规则说明 -->
            <div class="rule_sate">
                <div class="rule_title">-抽奖规则-</div>
                <div class="rule_content">
                    <p>1、本次抽奖活动每天限每个人抽1次；</p>
                    <p>2、用户可通过分享活动获取抽奖机会，每次分享可额外获得1次抽检机会，最多可获得三次机会；</p>
                    <p>3、所获奖项仅适用于其中1项，不可叠加使用</p>
                </div>
            </div>

        </div>

        <!-- 中奖弹窗 -->
        <award-draw @hidden="hiddenShow" v-show="isShowAward">
            <div class="winner_img">
                <img src="icon/awardIcon/winner_bg.png" alt="">
                <div class="draw_content" v-if="awardItem !== null">
                    <div class="price_font">{{awardItem.awardName || ''}}</div>
                    <div class="state_font">{{awardItem.remark || ''}}</div>
                </div>
                <div @click="$router.push('/cardroll')" class="btn_style use_btn">
                </div>
            </div>
            <div class="close_btn">
                <div @click="isShowAward = false" class="close_img award_colse">

                </div>
            </div>
        </award-draw>

         <!-- 没中奖弹窗 -->
        <award-draw v-show="isShowNoAward">
            <div class="winner_img">
                <img src="icon/awardIcon/no_winner_bg.png" alt="">
                <div class="draw_content">
                   <span class="no_award_tip">您没有中奖哦～</span>
                </div>
                <div @click="appHelper.showHint('点击右上角分享至哦~');" class="btn_style again_btn">
                </div>
            </div>
            <div class="close_btn">
                <div @click="isShowNoAward = false" class="close_img award_colse">

                </div>
            </div>
        </award-draw>
    </div>
</template>
<script>

// part
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// config
import appConfig from '../../appConfig';

// api
import userApi from '@api/user';
import lottoApi from '@comp/lotto/lottoApi';

// platformApi
import requestManager from '@comp/platformApi/requestManager'
import timerManager from '@comp/platformApi/timerManager.js';

// util
import deviceHelper from '@util/deviceHelper';
import consoleHelper from '@util/consoleHelper';
import objectHelper from '@util/objectHelper';
import arrayHelper from "@util/arrayHelper";
import windowHelper from "@util/windowHelper";
import appHelper from '@util/appHelper';

// modules
import awardModel from './awardComp/awardModel.vue'
import awardDraw from './awardComp/awardDraw.vue'
import urlHelper from "@util/urlHelper";

const config = {
    speed : 25, // move count per second,
    circleMore : 1,
    chanceCount : 2
};

export default {
    name: "drawAward",
    extends : shixunPagePart,
    data(){
        return{
            //中奖显示抽屉
            isShowAward:false,
            //不中奖显示抽屉
            isShowNoAward:false,
            height:0,
            dataItem:{},
            title:'抽奖分奖金',

            lottoInfo : null,
            itemCount : 7,
            currentNumber : 0,
            moveTimer : null,
            moveStatus : false,
            award : null,
            stopOnNumber : 3,
            chanceCount : config.chanceCount,

            awardSort:[1,2,3,5,8,7,6,4],
            count:0,
            awardItem:null,
            awardId:'',
            introduceCode:null,
        }
    },
    components:{
        awardModel, awardDraw,
    },
    methods:{
        back() {
             appHelper.back(this);
        },
        loadLottoInfo(id, callback) {

            let options = objectHelper.clone(lottoApi.get);
            options.data = {
                id : id
            };

            requestManager.request(options, callback);
        },

        getShare(value){
            this.isShowShare = value;
        },

        scrollState(){
            windowHelper.scrollTo(263);
        },
        hiddenShow(){
            this.isShowAward = false;
        },

        startMove(){
            consoleHelper.log('进入抽奖')
            const me = this;

            if (this.moveStatus)    // already moving
            {
                return;
            }

            // if (!this.chanceCount)
            // {
            //     appHelper.showHint('抽奖机会已用完了');
            //     return;
            // }

            //获取抽奖总次数
            if (!this.lottoInfo.lottoCount)
            {
                appHelper.showHint('抽奖机会已用完了');
                return;
            }

            // check time
            let nowTime = new Date().getTime();
            //判断活动是否开始
            if (nowTime < this.lottoInfo.startTime)
            {
                appHelper.showHint('抽奖活动还没有开始呢！');
                return;
            }
            //判断活动是否结束
            if (nowTime > this.lottoInfo.endTime)
            {
                appHelper.showHint('亲来晚啦，抽奖活动已结束了。');
                return;
            }

            // if (!this.chanceCount)
            // {
            //     appHelper.showHint('抽奖机会已用完了');
            //     return;
            // }
            //
            // this.chanceCount--;

            //点击一次抽奖数减少一次
            this.lottoInfo.lottoCount--;

            let options = objectHelper.clone(lottoApi.start);
            options.data = {
                lottoId : this.lottoInfo.id
            };
            requestManager.request(options, (error, result) => {

                if (error)
                {
                    appHelper.showHint(error);
                    return;
                }
                //拿到抽奖得到的id对应的信息
                let luckItem = arrayHelper.getItemByColumn(me.lottoInfo.awardList, 'id', result.data.awardId);

                me.awardItem = luckItem;

                //拿到id奖品对应下标
                me.stopOnNumber = arrayHelper.getIndex(me.lottoInfo.awardList, luckItem) + 1;
                // 获取奖品信息
                me.award = result.data;
                // let count = 0
                me.moveTimer = timerManager.setInterval(() => {
                    me.currentNumber = me.awardSort[me.count]
                    me.count++;

                    if (me.count > me.itemCount)
                    {
                        me.count = 0;

                    }

                    me.$forceUpdate();
                }, 1000 / config.speed);
                me.moveStatus = true;

                // stop after 3s
                timerManager.setTimeout(() => {
                    me.stopToNumber(this.stopOnNumber, () => {
                        if(me.awardItem && me.awardItem.type === 3){
                            me.isShowNoAward = true;
                        }else{
                            me.isShowAward = true;
                        }
                        // appHelper.showMessage('恭喜你中奖了！' + '获得' + me.award.awardName);
                    });
                }, 700);

            });
        },
        stop() {
            if (!this.moveStatus)    // not start
            {
                return;
            }

            if (this.stopOnNumber > this.itemCount || this.stopOnNumber < 1)    // out of range
            {
                return;
            }

            const me = this;
            this.stopToNumber(this.stopOnNumber, () => {
                appHelper.showMessage('恭喜你中奖了！' + '获得' + me.award.awardName);
            });
        },
        /**
         * stop to a number item
         * @param   Number      number
         * @param   Function    callback
         */
        stopToNumber(number, callback) {

            timerManager.clearInterval(this.moveTimer);

            const me = this;

            // 已再兜几个圈
            let t_circle = 0;
            this.moveTimer = timerManager.setInterval(() => {
                me.currentNumber = me.awardSort[me.count]

                consoleHelper.log('current number: ' + me.currentNumber);
                me.count++;
                if (me.count > me.itemCount)
                {
                    me.count = 0;
                }
                if (me.currentNumber == number)
                {
                    if (t_circle >= config.circleMore) // 圈数够就停
                    {
                        timerManager.clearInterval(me.moveTimer);
                        me.moveStatus = false;
                        callback ? callback() : null;
                    }
                    else    // 圈数不够继续
                    {
                        t_circle++;
                    }
                }
                consoleHelper.log('t_circle: ' + t_circle);

                me.$forceUpdate();
            }, 120)
        }
    },

    mounted(){

        const id = this.$route.params.id || '';
        this.awardId = id;
        if (!id)
        {
            appHelper.showHint('缺少id参数。');
            return;
        }
        requestManager.request(userApi.getUserData, (error, result) => {
            if (error)
            {
                consoleHelper.logError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint(result.errorCode + ': ' + result.msg);
                consoleHelper.logError(result.errorCode + ': ' + result.msg);
                return;
            }
            let user = result.data;
            this.introduceCode = user.introduceCode;

            // check introduceCode
            if (deviceHelper.isBrowser)
            {
                let urlIntroduceCode = urlHelper.getUrlParam('introduceCode') || '';
                if(urlIntroduceCode && urlIntroduceCode !== this.introduceCode){

                    requestManager.request({
                        method:'put',
                        url : '/portal/lotto/addShare',
                        params:{
                            id:this.awardId,
                            uCode: urlIntroduceCode
                        }
                    }, (error, result) => {

                        if (error)
                        {
                            appHelper.generalAjaxError(error);
                            return;
                        }
                    })
                }
            }
        });

        const me = this;
        this.loadLottoInfo(id, (error, result)=>{
            me.lottoInfo = result.data;
        });

    }
}
</script>
<style lang="scss" scoped>

.main{
    width: 100%;
    padding: 0 4%;
    box-sizing: border-box;
    background: #fff;
}

.title{
    width: 100%;
    height: 44px;
    text-align: center;
    line-height: 44px;
    font-size: 20px;

    font-weight: 600;
    color: #333333;

    overflow: hidden;

}
.back{
    float: left;
    margin-top: 4px;
}

.content{
    position: relative;
    width: 100%;
    height: 822px;
    // height: auto;
    overflow: hidden;
}

.img_bg{
    width: 100%;
    height: 822px;
}

.rule_btn{
    position: absolute;
    top: 2%;
    right: 0;
    width: 75px;
    height: 25px;
    line-height: 25px;
    text-align: center;
    background: #FFF570;

    border-radius: 32px 0px 0px 32px;


    font-size: 12px;

    font-weight: 500;
    color: #B56333;

}

.rule_sate{
    position: absolute;
    bottom: 5%;
    left: 4%;
    width: 92%;
    // height: 153px;
    padding: 6px 16px;
    border-radius: 4px;
    box-sizing: border-box;
    background: #FFFAEB;

    .rule_title{
        width: 100%;
        height: 22px;
        text-align: center;
        font-size: 16px;

        font-weight: 500;
        line-height: 22px;
        color: #B56333;


    }

    .rule_content{

        font-size: 12px;

        font-weight: 500;
        color: #484C5E;

    }

}

.no_award_tip{

    font-size: 16px;

    font-weight: 500;
    color: #FF5357;

}


.winner_img{
    width: 301px;
    height: 368px;
    position: relative;
    .draw_content{
        width: 100%;
        height: 70px;
        position: absolute;
        top: 43%;
        left: 50%;
        transform: translate(-50%,-50%);
        text-align: center;
        .price_font{

            font-size: 28px;

            font-weight: 500;
            // line-height: 54px;
            color: #FF5357;

        }
        .state_font{

            font-size: 16px;

            font-weight: 500;
            // line-height: 53px;
            color: #C98259;

        }

    }
    img{
        width: 100%;
        height: 100%;
    }
}

.close_btn{
    width: 100%;
    height: 34px;
    display: flex;
    justify-content: center;

}

.close_img{
    width: 34px;
    height: 34px;
}

.award_colse{
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url(data:image/png;base64,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);
}

.btn_style{
    width: 158px;
    height: 43px;
    position: absolute;
    bottom: 22%;
    left: 50%;
    transform: translateX(-50%);

}

.use_btn{
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url(data:image/png;base64,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);
}

.again_btn{
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url(data:image/png;base64,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);

}



</style>
